<template>
  <div>
    <div
      v-for="(q, i) in questions"
      :key="q.id"
      class="mb-4 pb-3"
      :class="{ 'border-bottom': i < questions.length - 1 }"
    >
      <div class="d-flex align-items-center gap-2 mb-2">
        <strong>{{ i + 1 }}. {{ q.title }}</strong>
        <span class="badge bg-light text-dark border">{{ questionTypeLabel(q.type) }}</span>
        <span v-if="q.required" class="badge bg-primary-soft">Obrigatória</span>
      </div>
      <ul v-if="q.options?.length" class="mb-0">
        <li v-for="(opt, oi) in q.options" :key="oi" class="text-muted">{{ opt }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
const questionTypeLabels = {
  single_choice: "Escolha única",
  multiple_choice: "Múltipla escolha",
  open_text: "Texto aberto",
};

export default {
  name: "SurveyQuestionsList",
  props: {
    questions: { type: Array, default: () => [] },
  },
  methods: {
    questionTypeLabel(type) {
      return questionTypeLabels[type] || type;
    },
  },
};
</script>
